<div
  class="fixed inset-0 z-30 flex items-center justify-center bg-main-background bg-opacity-75"
  (click)="cancelled.emit()">
  <div
    class="mx-4 w-full max-w-sm rounded-md bg-white p-6 shadow-lg"
    (click)="$event.stopPropagation()">
    <h2 class="oswald-font text-xl text-nside-gray-400">{{ title }}</h2>
    <p class="mt-2 text-sm text-gray-600" [innerHTML]="message"></p>
    <div class="mt-5 flex justify-end gap-2">
      <button
        type="button"
        (click)="cancelled.emit()"
        class="rounded-md border border-gray-300 px-4 py-1.5 text-sm oswald-font text-gray-600 hover:bg-gray-50">
        Cancel
      </button>
      <button
        type="button"
        (click)="confirmed.emit()"
        class="rounded-md border px-4 py-1.5 text-sm oswald-font text-white"
        [ngClass]="confirmDanger
          ? 'border-red-300 bg-red-500 hover:bg-red-600'
          : 'border-nside-orange-400 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 hover:from-nside-orange-400 hover:to-nside-orange-400'">
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</div>
